import { BooleanField, Datagrid, DataTable, DateField, List, Pagination, TextField, TextInput } from "react-admin";

const Pagination100 = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />;

const filters = [<TextInput label="Domain" source="domain" alwaysOn />]
export function LocaleList() {
    return (
        <List perPage={25}
            pagination={<Pagination100 />}
            filters={filters}
            exporter={false}
        >
            <DataTable rowClick="edit">
                <DataTable.Col source="id" label={"Language"} />
                
            </DataTable>
        </List>
    )

}